var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ReportPage_1, Report_1;
import { IsBoolean, ValidateIf } from "class-validator";
import { GraphQLNonEmptyString } from "graphql-scalars";
import { ArgsType, Field, ObjectType } from "type-graphql";
import { SolicitationCodeTag } from "../resources/SolicitationCode.js";
import { TeamType } from "../resources/Team.js";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { IsAfterDateTime, IsBeforeDateTime, } from "../validation/beforeAfter.js";
let ReportPage = ReportPage_1 = class ReportPage {
    title;
    header;
    rows;
    static newEmpty(title) {
        const page = new ReportPage_1();
        page.title = title;
        page.header = [];
        page.rows = [];
        return page;
    }
    static fromJson(title, keys, data) {
        const page = ReportPage_1.newEmpty(title);
        page.header = keys;
        page.rows = data.map((row) => keys.map((key) => (row[key] != null ? String(row[key]) : "")));
        return page;
    }
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], ReportPage.prototype, "title", void 0);
__decorate([
    Field(() => [String], { nullable: false }),
    __metadata("design:type", Array)
], ReportPage.prototype, "header", void 0);
__decorate([
    Field(() => [[String]], { nullable: false }),
    __metadata("design:type", Array)
], ReportPage.prototype, "rows", void 0);
ReportPage = ReportPage_1 = __decorate([
    ObjectType()
], ReportPage);
export { ReportPage };
let Report = Report_1 = class Report {
    pages;
    static newEmpty() {
        const report = new Report_1();
        report.pages = [];
        return report;
    }
    static fromJson(keys, data) {
        const report = Report_1.newEmpty();
        report.pages = data.map(({ data, title }) => ReportPage.fromJson(title, keys, data));
        return report;
    }
};
__decorate([
    Field(() => [ReportPage], { nullable: false }),
    __metadata("design:type", Array)
], Report.prototype, "pages", void 0);
Report = Report_1 = __decorate([
    ObjectType()
], Report);
export { Report };
let FundraisingReportArgs = class FundraisingReportArgs {
    from;
    to;
    solicitationCodeIds;
    solicitationCodeTags;
    requireAllTags;
    report;
};
__decorate([
    IsBeforeDateTime("to"),
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], FundraisingReportArgs.prototype, "from", void 0);
__decorate([
    IsAfterDateTime("from"),
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], FundraisingReportArgs.prototype, "to", void 0);
__decorate([
    Field(() => [GlobalIdScalar], { nullable: true }),
    __metadata("design:type", Object)
], FundraisingReportArgs.prototype, "solicitationCodeIds", void 0);
__decorate([
    Field(() => [SolicitationCodeTag], { nullable: true }),
    __metadata("design:type", Object)
], FundraisingReportArgs.prototype, "solicitationCodeTags", void 0);
__decorate([
    ValidateIf((o) => o.solicitationCodeTags != null),
    IsBoolean({
        message: "If solicitationCodeTags is provided, requireAllTags must also be provided",
    }),
    Field(() => Boolean, { nullable: true }),
    __metadata("design:type", Object)
], FundraisingReportArgs.prototype, "requireAllTags", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], FundraisingReportArgs.prototype, "report", void 0);
FundraisingReportArgs = __decorate([
    ArgsType()
], FundraisingReportArgs);
export { FundraisingReportArgs };
let TeamReportArgs = class TeamReportArgs {
    from;
    to;
    marathonYears;
    teamIds;
    teamTypes;
    report;
};
__decorate([
    IsBeforeDateTime("to"),
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], TeamReportArgs.prototype, "from", void 0);
__decorate([
    IsAfterDateTime("from"),
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], TeamReportArgs.prototype, "to", void 0);
__decorate([
    Field(() => [GlobalIdScalar], { nullable: true }),
    __metadata("design:type", Object)
], TeamReportArgs.prototype, "marathonYears", void 0);
__decorate([
    Field(() => [GlobalIdScalar], { nullable: true }),
    __metadata("design:type", Object)
], TeamReportArgs.prototype, "teamIds", void 0);
__decorate([
    Field(() => [TeamType], { nullable: true }),
    __metadata("design:type", Object)
], TeamReportArgs.prototype, "teamTypes", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], TeamReportArgs.prototype, "report", void 0);
TeamReportArgs = __decorate([
    ArgsType()
], TeamReportArgs);
export { TeamReportArgs };
//# sourceMappingURL=ReportParams.js.map